import '../common/_icons';
import { ElementCollapse } from '../common/components/ElementCollapse';
import { CheckboxCollapse } from '../common/components/CheckboxCollapse';

// import basic from admin
import '.';

ElementCollapse.init();
CheckboxCollapse.init();

const page = document.querySelector('[data-page-name]');
const currentPageName = page?.dataset?.pageName;

if (currentPageName === 'create-invoice-page') {
	import(/* webpackChunkName: "create-invoice-page" */ './invoice').then((module) => {
		const { AdminInvoice } = module;
		AdminInvoice.init();
	});
}
